import { render, staticRenderFns } from "./Post.vue?vue&type=template&id=461e2709&scoped=true&"
import script from "./Post.vue?vue&type=script&lang=js&"
export * from "./Post.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Post.vue?vue&type=style&index=0&id=461e2709&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "461e2709",
  "4efb0685"
  
)

export default component.exports